import { Component, DoCheck, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { AlertService, AuthenticationService } from 'src/app/shared/_services';
import { DashboardStore, LoginStore } from 'src/app/shared/_services/store';
import { UpgradeStore } from 'src/app/shared/_services/store/upgradeStore.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss']
})
export class ProfilePage implements OnInit, DoCheck {
  currentUserName = this.dashboardStore.getCurrentUserName();
  currentUser: any;
  subscription: any;
  cordova: boolean;
  gotStatus = false;
  upgraded = false;
  accountStatus: string;
  appVersion = this.loginStore.getAppVersion();
  profileActions = ['Profile Details', 'Security Settings'];
  approved = false;

  constructor(
    private router: Router,
    private platform: Platform,
    private loginStore: LoginStore,
    private alertService: AlertService,
    private upgradeStore: UpgradeStore,
    private auth: AuthenticationService,
    private dashboardStore: DashboardStore,
  ) {
    this.currentUser = this.auth.currentUserValue;
   }

  selectProfileAction(action: any) {
    if (action === 'Profile Details') {
      this.router.navigateByUrl('/profile/profile-details');
    } else if (action === 'Security Settings') {
      this.router.navigateByUrl('/profile/security-settings');
    } else {
      this.router.navigateByUrl('/profile/notification-settings');
    }
  }

  uploadPhoto() {
    this.alertService.standardAlert('Profile picture upload coming soon.😉');
  }

  refer() {
    this.router.navigateByUrl('/profile/refer');
  }

  upgradeAccount() {
    this.router.navigateByUrl('upgrade-account?select=true');
  }

  goBack() {
    this.router.navigateByUrl('/dashboard');
  }

  checkForStatus() {
    if (this.upgradeStore.getIsStatusOk() === 'true') {
      this.accountStatus = this.upgradeStore.getAccountCategory();
      this.gotStatus = true;
      this.upgradeStore.getAccountDocumentStatus().forEach((element: any) => {
        if (element.Category !== null) {
          if (element.Status === 'Approved') {
            this.approved = true;
            if (element.Category.includes('3')) {
              this.upgraded = true;
            }
          }
        }
      });
    }
  }

  ionViewWillEnter() {
    document.title = 'Profile | Bank3D';
  }

  ionViewDidEnter() {
    this.subscription = this.platform.backButton.subscribeWithPriority(99999, () => {
      this.goBack();
    });
  }

  ionViewDidLeave() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.cordova = this.platform.is('cordova');
    // onpopstate = (() => {
    //   this.goBack();
    // });
  }

  ngDoCheck(): void {
    this.gotStatus = false;
    this.checkForStatus();
  }
}
